import script from "./alertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./alertModal.vue?vue&type=script&setup=true&lang=js"

import "./alertModal.vue?vue&type=style&index=0&id=3bc6b406&lang=css"

const __exports__ = script;

export default __exports__